'use client';

import { useTranslation } from 'react-i18next';

import type { Collaborator } from '@/app/models/collaborator';
import DataTable, { type Column, bodyCellSx } from '@/components/common/DataTable';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, TableCell } from '@mui/material';

interface NewConsiderCollaboratorTableProps {
  collaborators: Collaborator[];
  onRemove: (collaborator: number) => void;
}

export default function NewConsiderCollaboratorTable({ collaborators, onRemove }: NewConsiderCollaboratorTableProps) {
  const { t } = useTranslation('considerCollaborator');

  const handleDelete = (id: number) => {
    if (id) {
      onRemove(id);
    }
  };

  const columns: Column[] = [
    {
      key: 'collaborator',
      label: t('collaborator'),
      align: 'left',
      width: '80%',
    },
    {
      key: 'actions',
      label: '',
      align: 'center',
      width: '20%',
    },
  ];

  const renderRow = (collaborator: Collaborator) => (
    <>
      <TableCell sx={bodyCellSx}>{`${collaborator.badge} - ${collaborator.name}`}</TableCell>
      <TableCell sx={bodyCellSx} align="center">
        <IconButton size="small" onClick={() => handleDelete(collaborator.id)}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      </TableCell>
    </>
  );

  const getRowKey = (collaborator: Collaborator) => collaborator.id;

  return (
    <DataTable
      columns={columns}
      data={collaborators}
      renderRow={renderRow}
      emptyMessage={t('no.collaborators.selected')}
      getRowKey={getRowKey}
      size="small"
      stickyHeader={false}
    />
  );
}
